define('RPC', [
	'logger',
	'request',
	'Emitter',
	'Promise',
	'utils/util'
], function (
	/** logger */logger,
	/** request */request,
	/** Emitter */Emitter,
	/** Promise */Promise,
	/** util */util
) {
	"use strict";


	var R_URL_VERSION = /^\/?v\d+/,
		R_URL_LAST_SLASH = /\/$/,
		R_URL_FIRST_SLASH = /^\//,
		R_URL_2xSLASH = /\/{2,}/g,
		R_URL_NO_FIRST_2xSLASH = /([^$\/])\/+/g,

		_stringify = JSON.stringify,
		_cloneObject = util.cloneObject
	;


	/**
	 * Объект для работы с API.
	 * Для подключения дополнительный возможностей, таких как обработка SDC и т.п. нужно [их подключить](statuses/) ;]
	 * @class  RPC
	 * @mixes  Emitter
	 */
	var RPC = {
			all: Promise.all,
			request: request,
			Promise: Promise,
			errorHandler: []
		},

		_settings = {
			version: 1,
			sdcUrl: '//auth.mail.ru/sdc',
			baseUrl: '//api.mail.ru/',
			timeout: 10000,
			email: '',
			token: '',
			htmlencoded: false,
			tokenRetries: 2,
			emulateHTTP: true,
			session: ''
		},

		_hasOwn = Object.prototype.hasOwnProperty;


	/**
	 * Трансляция кодов ответа в имена статусов API.
	 * @type {Object}
	 * @memberof RPC
	 */
	RPC.codes = {
		102: 'processing',
		200: 'ok',
		202: 'accepted',
		203: 'non_authoritative',
		206: 'partial',
		301: 'move',
		304: 'notmodified',
		400: 'invalid',
		402: 'payment_required',
		403: 'denied',
		404: 'notfound',
		406: 'unacceptable',
		408: 'timeout',
		409: 'conflict',
		417: 'expectation_failed',
		422: 'unprocessable',
		423: 'locked',
		424: 'failed_dependency',
		426: 'upgrade_required',
		429: 'many_requests',
		449: 'retry_with',
		451: 'unavailable_for_legal_reasons',
		500: 'fail',
		501: 'not_implemented',
		503: 'unavaliable',
		507: 'insufficient'
	};


	/**
	 * Трансляция статусов в коды ответа API.
	 * @type {Object}
	 * @memberof RPC
	 */
	RPC.statuses = {};
	for (var code in RPC.codes) {
		RPC.statuses[RPC.codes[code]] = code;
	}


	// Делаем из входных данных для RPC.mock объект для $.mockjax
	function _makeMockSettings(path, settings) {
		if (typeof path === 'object') {
			settings = path;
			path = settings.url;
		}

		settings = settings || /* istanbul ignore next */ {};
		var data = settings.data || {};

		return {
			url: RPC.normalizeUrl(path),
			once: settings.once,
			contentType: 'application/json',
			type: settings.type,
			headers: settings.headers || {},
			responseTime: settings.responseTime || 15,
			data: data,
			responseText: _stringify(settings.responseText || {
				body: settings.body || '',
				status: settings.status || /* istanbul ignore next */ 200,
				email: settings.email || '',
				htmlencoded: settings.htmlencoded || '',
				last_modified: settings.last_modified || ''
			}),
			response: settings.response
		};
	}


	// Создаем объект запроса, указанного типа (POST/GET)
	function _call(path, data, options, type) {
		options = _cloneObject(options);
		options.type = type;
		options.loggerMeta = options.loggerMeta || logger.meta(-2);

		return RPC.call(path, data, options);
	}


	/**
	 * Метод для установки/получения настроек.
	 * @static
	 * @method
	 * @memberof RPC
	 * @param  {Object|string}  [options]  Может быть как объектом настроек, так и строковым ключом
	 * @param  {*}  [value]  Используется только для установки значения
	 * @returns {*}
	 */
	RPC.setup = function (options, value) {
		if (options === undefined) { // get all settings
			return _settings;
		} else {
			if (value !== undefined) { // set setting
				_settings[options] = value;
			} else if (typeof options === 'string') { // get setting, options - is a key
				return _settings[options];
			} else {
				for (var key in options) { // set bundle of settings
					/* istanbul ignore next */
					if (_hasOwn.call(options, key)) {
						_settings[key] = options[key];
					}
				}
			}
		}
	};

	/**
	 * Нормализация пути
	 * @static
	 * @method
	 * @memberof RPC
	 * @param   {string}  path  вызываемый метод
	 * @returns {string}
	 */
	RPC.normalizeUrl = function (path) {
		var baseUrl = _settings.baseUrl;
		var url = String(path || "");

		/* istanbul ignore else */
		if (R_URL_FIRST_SLASH.test(url)) {
			url = url.replace(R_URL_NO_FIRST_2xSLASH, '$1/');
		} else if (url.indexOf(baseUrl) === -1) {
			if (_settings.version && !R_URL_VERSION.test(url)) {
				url = '/v' + _settings.version + '/' + url;
			}

			// Вырезаем все повторяющиеся слеши, кроме первых двух
			url = baseUrl.replace(R_URL_LAST_SLASH, "") + ("/" + url).replace(R_URL_2xSLASH, "/");
		}

		return url;
	};

	/**
	 * Метод для получения URL конца API
	 * @static
	 * @method
	 * @memberof RPC
	 * @param  {string} method  название метода или абсолютный если начинается с "/" или "//"
	 * @param  {object} [data]  данные запроса
	 * @return {string}
	 */
	RPC.url = function (method, data) {
		return RPC.normalizeUrl(method);
	};

	/**
	 * Метод проверяет активна ли для пользователя безопасная сессия (см. [Авторизация](http://api.tornado.dev.mail.ru/auth))
	 * @static
	 * @method
	 * @memberof RPC
	 * @returns {boolean}
	 */
	RPC.hasSession = function () {
		return !!_settings.session;
	};

	/**
	 * Метод для проверки наличия токена
	 * @static
	 * @method
	 * @memberof RPC
	 * @return {boolean}
	 */
	RPC.hasToken = function () {
		return !!_settings.token;
	};


	/**
	 * Метод, сбрасывыющий токен
	 * @static
	 * @method
	 * @memberof RPC
	 */
	RPC.resetToken = function () {
		_settings.token = '';
	};


	/**
	 * Получение токена. В случае успешного выполнения устанавливает полученный токен.
	 * @static
	 * @memberof RPC
	 * @return {Promise}
	 */
	RPC.token = function () {
		return RPC.call('tokens').then(function (/* RPC.Request */req) {
			/* jshint expr:true */
			return (_settings.token = req.get('body.token'));
		});
	};


	/**
	 * Универсальный метод для отправки запроса к API.
	 * В случае ответа xhr.is('denied:token') запрашивает токен.
	 * @static
	 * @method
	 * @memberof RPC
	 * @param  {string}        method метод API
	 * @param  {Object}        [data] данные запроса
	 * @param  {Object}        [options] настройки для request
	 * @return {RPC.Request}
	 */
	RPC.call = function call(method, data, options) {
		options = _cloneObject(options);
		options.timeout = options.timeout || _settings.timeout;
		options.Request = RPCRequest;
		options.dataType = 'json';
		options.type = options.type ? options.type.toUpperCase() : 'POST';
		options.loggerMeta = options.loggerMeta || logger.meta(-1);

		data  = _cloneObject(data || {});

		/* istanbul ignore else */
		if (!data.email && _settings.email) {
			data.email = _settings.email;
		}

		/* jshint eqnull:true */
		/* istanbul ignore else */
		if (_settings.htmlencoded != null) {
			data.htmlencoded = _settings.htmlencoded;
		}

		/* istanbul ignore else */
		if (_settings.token) {
			data.token = _settings.token;
		}

		/* istanbul ignore else */
		if (_settings.emulateHTTP === true && options.type != 'GET' && options.type != 'POST') {
			options.type = 'POST';
		}

		/* istanbul ignore else */
		if (_settings.session) {
			data.session = _settings.session;
		}

		options.logger = options.logger || method;

		return request(RPC.url(method, data), RPC.serialize(data), options);
	};

	/**
	 * Метод сериализации данных, перед отправкой
	 * может быть переопределен
	 * @static
	 * @method
	 * @memberof RPC
	 * @param {*} data - даные
	 * @returns {*}
	 */
	RPC.serialize = function (data) {
		return data;
	};

	/**
	 * Метода для совершения GET зароса
	 * @static
	 * @method
	 * @memberof RPC
	 * @param    {string}        path       метод API
	 * @param    {Object}        [data]     данные запроса
	 * @param    {Object}        [options]  опции
	 * @returns  {RPC.Request}
	 */
	RPC.get = function get(path, data, options) {
		return _call(path, data, options, 'GET');
	};


	/**
	 * Метода для совершения POST зароса
	 * @static
	 * @method
	 * @memberof RPC
	 * @param    {string}        path       метод API
	 * @param    {Object}        [data]     данные запроса
	 * @param    {Object}        [options]  опции
	 * @returns  {RPC.Request}
	 */
	RPC.post = function post(path, data, options) {
		return _call(path, data, options, 'POST');
	};


	/**
	 * Выполнить действия «пачкой»    ***Экспериментальный метод***
	 * @static
	 * @method
	 * @memberof RPC
	 * @param	{Function} executor
	 * @returns {Promise}
	 */
	RPC.batch = function (executor) {
		return request.batch(executor, this.url('batch'));
	};


	/**
	 * Эмуляция XHR
	 * @static
	 * @method
	 * @memberof RPC
	 * @param    {string}   path        Имя метода API
	 * @param    {Object}   [settings]  Результат запроса
	 * @return   {number}               id мока
	 */
	RPC.mock = function (path, settings) {
		return request.mock(_makeMockSettings(path, settings));
	};


	/**
	 * Разовая эмуляция XHR
	 * @static
	 * @method
	 * @memberof RPC.mock
	 * @param    {string}  path        Имя метода API
	 * @param    {Object}  [settings]  Результат запроса
	 * @returns  {number}              id мока
	 */
	RPC.mock.once = function (path, settings) {
		return request.mock.once(_makeMockSettings(path, settings));
	};


	/**
	 * Объект запроса RPC
	 * @class Request
	 * @memberOf RPC
	 * @constructs RPC.Request
	 * @extends request.Request
	 */
	var RPCRequest = function () {
		/**
		 * Время изменения, аналог If-Modified-Since HTTP заголовка.
		 * @type {number}
		 * @name lastModified
		 * @memberof RPC.Request#
		 */
		this.lastModified = null;

		/**
		 * Флаг, указывающий на включенное/отключенное htmlencode
		 * конвертирование значений полей в ответе API.
		 * @type {boolean}
		 * @name htmlencoded
		 * @memberof RPC.Request#
		 */
		this.htmlencoded = null;

		/**
		 * email учетки, над которой производится действие
		 * @type {string}
		 * @name email
		 * @memberof RPC.Request#
		 */
		this.email = null;

		/**
		 * Имя статуса ответа API.
		 * @type {string}
		 * @name statusName
		 * @memberof RPC.Request#
		 */
		this.statusName = null;

		return request.Request.apply(this, arguments);
	};

	// Extend
	RPCRequest.prototype = Object.create(request.Request.prototype, {
		constructor: {value: RPCRequest}
	});


	/**
	 * Завершить запрос
	 * @name RPC.Request#end
	 * @method
	 * @param  {string|boolean} err
	 * @param  {Object} api
	 * @return {*}
	 */
	RPCRequest.prototype.end = function (err, api) {
		// сохраняем реальный статус
		this.httpStatus = this.status;
		
		if (!err && !this.aborted) {
			// Всё ок, API ответило корретно, никаких http ошибок
			for (var key in api) {
				/* istanbul ignore else */
				if (_hasOwn.call(api, key)) {
					this[util.toCamelCase(key)] = api[key];
				}
			}

			// Преобразуем код в название статуса
			this.statusName = RPC.codes[api.status];

			// если пользователю была выставлена безопасная сессия, то сохранить ее
			if (api.session) {
				_settings.session = api.session;
			}

			// В родительский метод передаем именно ответ api.body
			api = api.body;
			err = err || !this.isOK(); // todo: проверить всё это
		}

		// вызываем родительский метод
		return request.Request.fn.end.call(this, err, api);
	};


	/**
	 * Проверить свойство на истинность
	 * @param  {string}  keys
	 * @return {boolean}
	 * @method RPC.Request#is
	 */
	RPCRequest.prototype.is = function (keys) {
		var R_STATUS = /\b(\w+)(?::(\w+))?\b/g, // Не кешируем RegExp, а то «криво» будет работа exec
			key,
			val,
			matches;

		while (!!(matches = R_STATUS.exec(keys))) {
			key = matches[1]; // статус
			val = matches[2]; // значение

			if (RPC.statuses[key] == this.status && (!val || this.body == val)) {
				return true;
			}
		}

		return request.Request.fn.is.call(this, keys);
	};



	// Доступ к RPCRequest
	RPC.Request = RPCRequest;


	// Подмешиваем Emitter
	Emitter.apply(RPC);


	// Обработка ошибок
	request.on('error', function (evt, req) {
		var i = RPC.errorHandler.length,
			handle,
			result;

		while (i--) {
			handle = RPC.errorHandler[i];

			if (req.is(handle.status)) {
				result = handle.process(req);

				/* istanbul ignore else */
				if (result) {
					evt.preventDefault();
					return req.retry(result, true);
				}
			}
		}
	});


	/**
	 * Создать `RPC.Request` из XHR
	 * @param  {string} url
	 * @param  {Object} data
	 * @param  {Object|XMLHttpRequest} xhr
	 * @return {RPC.Request}
	 * @memberOf RPC
	 */
	RPC.from = function (url, data, xhr) {
		var req = request.from.apply(request, arguments);

		/* istanbul ignore else */
		if (req.isOK()) {
			req.status = req.get('body.status');
			req.body = req.get('body.body');
		}

		return req;
	};


	/**
	 * Интеграция произвольного функционала в рабочий процесс отправки и обработки запроса к API
	 * @param  {Object}    options    опции запроса
	 * @param  {Function}  transport  функция отправки запроса
	 * @return {RPC.Request}
	 * @method
	 * @memberOf RPC
	 */
	RPC.workflow = request.workflow;


	// Export
	RPC.version = '0.10.1';
	return RPC;
});
